import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../../app/store";
import { TBS_API_URL, TBS_TENANT_ID } from "../../config";
import type { DailyBudgetResponse } from "../../types/types";

// Tiendas Biai — reports.
//
// **The response type is the storefront's own `DailyBudgetResponse`**, imported rather than
// redeclared. That is the point of REP-1: if this endpoint ever stops fitting that type, the
// compiler says so, and the contabilidad screen's backend swap is a URL change.

export const tbsReportsApi = createApi({
  reducerPath: "tbsReportsApi",
  tagTypes: ["TbsReport"],
  baseQuery: fetchBaseQuery({
    baseUrl: TBS_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      if (TBS_TENANT_ID) headers.set("X-Tenant-Id", TBS_TENANT_ID);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    /** `date` omitted → today in America/Bogota, decided server-side, exactly as today. */
    getDailyResume: builder.query<DailyBudgetResponse, { date?: string } | void>({
      query: (params) => `/v1/reports/daily-resume${params?.date ? `?date=${params.date}` : ""}`,
      providesTags: ["TbsReport"],
    }),
  }),
});

export const { useGetDailyResumeQuery } = tbsReportsApi;
